import { AutomationModule } from "@/store/modules/automation.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const automationsMachine = Machine({
    id: "automationsMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "title",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_AUTOMATIONS: { target: "gettingAutomations", actions: "assignSearchData" },
            },
        },
        gettingAutomations: {
            tags: "showloader",
            invoke: {
                id: "gettingAutomations",
                src: (context, event) => {
                    return AutomationModule.GetAutomations(context.searchData);
                },
                onDone: { target: "loadedAutomations" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedAutomations: {
            initial: "idle",
            states: {
                idle: {
                    on: {
                        GETTING_AUTOMATIONS: { target: "#automationsMachine.gettingAutomations", actions: "assignSearchData" },
                        ARCHIVE_AUTOMATION: { target: "archiveAutomation", actions: "ispageChanged" },
                    },
                },
                archiveAutomation: {
                    tags: "showarchiveAutomationUI",
                    on: {
                        ARCHIVING_AUTOMATION: { target: "archivingAutomation" },
                        CANCEL: { target: "idle" },
                    },
                },
                archivingAutomation: {
                    tags: "showarchiveAutomationUI",
                    invoke: {
                        id: "archivingAutomation",
                        src: (context, event) => {
                            return AutomationModule.ArchiveAutomationById(event.automationId);
                        },
                        onDone: { target: "#automationsMachine.gettingAutomations", actions: ["showSuccessMessage", "setPage"] },
                        onError: { target: "idle" },
                    },
                },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default automationsMachine;
